import { CellContext, RowData } from '@tanstack/react-table';
import { TextEllipsis } from '../../../components';

export const renderDefaultCell = <TData extends RowData>(
  props: CellContext<TData, any>
) => <TextEllipsis>{props.renderValue()}</TextEllipsis>;
